import React, { useState, useEffect } from 'react';

/**
 * Hooks
 */
import { useTranslation } from 'react-i18next';
import useToken from '../../hooks/useToken';

/**
 * MUI Components
 */
import { Button, Box } from '@mui/material';

/**
 * Components
 */
import VehicleSelector from '../Vehicles/VehicleSelector';

/**
 * Utils
 */
import { fetchVehicles } from '../../utils/api';

const styles = {
    formBox: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
    }
};

const AddVehicleForm = ({ onSubmit, planning }) => {
    const { t } = useTranslation();
    const [vehicles, setVehicles] = useState([]);
    const [vehicle, setVehicle] = useState([]);
    const [loadingVehicles, setLoadingVehicles] = useState(false);
    const { token } = useToken();

    useEffect(() => {
        const abortController = new AbortController();
        const signal = abortController.signal;

        setLoadingVehicles(true);
        try {
            fetchVehicles(token, signal).then(vehicles => {

                // Before set the vehicles, filter out the vehicles that are already in the planning
                const planningVehicles = planning?.vehicles || [];
                const filteredVehicles = vehicles.filter(v => !planningVehicles.some(pv => pv.id === v.id));

                setVehicles(filteredVehicles);
            });
        } catch (error) {
            console.error('Error fetching vehicles', error);
        } finally {
            setLoadingVehicles(false);
        }

        return () => abortController.abort();
    }, [token]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if ((Array.isArray(vehicle) && !vehicle.length) || typeof vehicle !== 'object') return;

        if (Array.isArray(vehicle)) {
            onSubmit({ ...vehicle[0] });
        } else {
            onSubmit({ ...vehicle });
        }
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={styles.formBox}>
            <VehicleSelector
                vehicles={vehicles}
                loading={loadingVehicles}
                value={vehicle}
                onChange={setVehicle}
                multiple={false}
                required
            />

            <Button disabled={(Array.isArray(vehicle) && !vehicle.length) || typeof vehicle !== 'object'} variant="contained" color="primary" type="submit">
                {t('Add')}
            </Button>
        </Box>
    );
};

export default AddVehicleForm;